<template>
    <v-row>
        <!-- LEFT CARD -->
        <v-col cols="12" md="6">
            <v-card>
                <v-toolbar density="compact" color="primary">
                    <v-toolbar-title> {{ $t("company.paymentIncidentCount") }} </v-toolbar-title>
                </v-toolbar>
                <v-card-text> {{ $t("addPaymentIncident.cardDescription") }} </v-card-text>
            </v-card>
            <div class="d-flex flex-row justify-center mt-5">
                <v-btn color="primary" @click="addPaymentIncident">
                    {{ $t("addPaymentIncident.button") }}
                </v-btn>
            </div>
        </v-col>
        <!-- RIGHT CARD -->
        <v-col cols="12" md="6">
            <v-card>
                <v-toolbar density="compact" color="primary">
                    <v-toolbar-title> {{ $t("company.transportIncidentCount") }} </v-toolbar-title>
                </v-toolbar>
                <v-card-text>{{ $t("addTransportIncident.cardDescription") }}</v-card-text>
            </v-card>
            <div class="d-flex flex-row justify-center mt-5">
                <v-btn color="primary" @click="addTransportIncident">
                    {{ $t("addPaymentIncident.button") }}
                </v-btn>
            </div>
        </v-col>
    </v-row>
</template>

<script>
import BulletCard from "@/components/display/BulletCard.vue";

export default {
    name: "IncidentsIntroduction",
    components: { BulletCard },
    methods: {
        addPaymentIncident() {
            // e.g. navigate or open a form
            this.$router.push("/dashboard/add-payment-incident");
        },
        addTransportIncident() {
            // e.g. navigate or open a form
            this.$router.push("/dashboard/add-transport-incident");
        },
    },
};
</script>
